import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    owners: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    owners(state) {
      return state.owners;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.owners = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_OWNERS(state, payload) {
      state.owners = payload;
    },
    SORT_OWNERS_BY_NAME(state, order) {
      if (!order) return;
      switch (order.toUpperCase()) {
        case "DESC":
          state.owners.sort((a, b) => {
            if (a.fullName > b.fullName) return -1;
            if (b.fullName > a.fullName) return 1;
            return 0;
          });
          break;
        case "ASC":
        default:
          state.owners.sort((a, b) => {
            if (a.fullName > b.fullName) return 1;
            if (b.fullName > a.fullName) return -1;
            return 0;
          });
      }
    },
    ADD_OWNER(state, owner) {
      if (!owner) return;
      state.owners.push(owner);
    },
    UPDATE_OWNER(state, owner) {
      if (!state.owners.length || !owner) return;
      const ownerIndex = state.owners.findIndex((c) => c.uuid === owner.uuid);
      if (ownerIndex === -1) return;
      state.owners.splice(ownerIndex, 1, owner);
    },
    REMOVE_OWNER(state, ownerUuid) {
      if (!ownerUuid) return;
      const ownerIndex = state.owners.findIndex((c) => c.uuid === ownerUuid);
      if (ownerIndex === -1) return;
      state.owners.splice(ownerIndex, 1);
    },
    UPDATE_OWNER_LOCATION(state, payload) {
      if (!state.owners.length) return;
      const ownerIndex = state.owners.findIndex(
        (c) => c.uuid === payload.owner.uuid
      );
      if (ownerIndex === -1) return;
      state.owners[ownerIndex].location = payload.location;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchOwners({ commit }, payload = { pagination: false, sort: "asc" }) {
      commit("SET_LOADING", true);

      let url = "/owners?";
      if ("pagination" in payload) url += `pagination=${payload.pagination}`;

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_OWNERS", response.data["hydra:member"]);
              if (payload.sort && typeof payload.sort === "string") {
                commit("SORT_OWNERS_BY_NAME", payload.sort);
              }
              resolve(response);
            } else {
              reject(
                new Error({
                  status: response.status,
                  message: "Error while fetching all the owners",
                })
              );
            }
          })
          .catch((error) => reject(error.response))
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
